module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/Block4-2857d43b6969e9499869c6b6f9a6e97f.png";